import clsx from 'clsx'
import { ControlLabel, HelperText, Radio, Typography } from 'gu-ui-kit'
import React from 'react'
import styles from 'components/FormControls/form-controls.module.scss'

const renderRadioGroup = ({
  className = '',
  label,
  input,
  meta: { touched, error, submitting },
  options,
  ...rest
}) => {
  return (
    <div
      onChange={(event) => {
        event.stopPropagation()
        input.onChange(event.target.value)
      }}
      className={className}
    >
      {label && (
        <Typography variant={'p7'} noMargin style={{ marginBottom: '10px' }}>
          {label}
        </Typography>
      )}
      {options.map((option, i) => (
        <div key={input.name + '-' + i}>
          <ControlLabel
            error={option.value === input.value && touched && error}
            checked={option.value === input.value}
            control={<Radio />}
            {...option}
            id={input.name + '-' + i}
            name={input.name}
            disabled={submitting || rest.disabled}
          />
        </div>
      ))}

      {(error || rest.helperText) && (
        <HelperText
          error={error}
          className={clsx(styles['radiogroup__helper-text'], {
            [styles['radiogroup__helper-text_error']]: error,
          })}
        >
          {rest.t(error) || rest.helperText}
        </HelperText>
      )}
    </div>
  )
}

export default renderRadioGroup
